import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "col-sm-12"
}
const _hoisted_5 = { class: "card card-body mb-3" }
const _hoisted_6 = { class: "navbar-nav overflow-auto flex-row gap-4 mb-0" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PayInRequisites = _resolveComponent("PayInRequisites")!
  const _component_RequisiteTemplates = _resolveComponent("RequisiteTemplates")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.templatesTabAvailable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("ul", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Tabs, (value, tab) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: tab,
                      class: "nav-item nav-item-spaced d-lg-block text-nowrap"
                    }, [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _withModifiers(($event: any) => (_ctx.selectTab(tab)), ["prevent"]),
                        class: _normalizeClass(["nav-link tab", {'active': _ctx.activeTabName === tab}])
                      }, _toDisplayString(_ctx.helper.trans(`requisites.templates.admin.tab_${tab}`)), 11, _hoisted_7)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTabName === _ctx.Tabs.pay_in)
          ? (_openBlock(), _createBlock(_component_PayInRequisites, { key: 1 }))
          : (_ctx.activeTabName === _ctx.Tabs.templates && _ctx.templatesTabAvailable)
            ? (_openBlock(), _createBlock(_component_RequisiteTemplates, { key: 2 }))
            : _createCommentVNode("", true)
      ])
    ])
  ]))
}